import VueScrollTo from 'vue-scrollto'

export function cleanObj (o) {
  for (const n in o) {
    if ((o[n] === null || o[n] === undefined) ||
        (typeof o[n] === 'number' && o[n] === 1) ||
        (typeof o[n] === 'boolean' && !o[n])) {
      delete o[n]
    }
  }
}

export function isValidDate (d) {
  return d instanceof Date && !isNaN(d)
}

export function loadJS (u) {
  return new Promise((resolve, reject) => {
    const r = document.getElementsByTagName('script')[0]
    const s = document.createElement('script')
    s.src = u
    s.onload = resolve
    s.onerror = reject
    r.parentNode.insertBefore(s, r)
  })
}

export function imgSizes ({ srcset, dimensions }) {
  const imgs = srcset.split(' ').filter(i => i.includes('http'))
  const widths = srcset.split(' ').filter(i => !i.includes('http'))

  const sizes = []
  imgs.forEach((img, i) => {
    const w = widths[i] ? parseInt(widths[i].replace('w', '')) : dimensions.width
    const rule = `(max-width: ${w - 100}px) ${w}px`
    sizes.push(rule)
  })
  return sizes.join(',')
}

export function getYears (list = []) {
  const y = new Set()
  list.forEach((p) => {
    // eslint-disable-next-line
    const start = !!p.start_time ? p.start_time : p.start
    const d = new Date(start)
    if (isValidDate(d)) {
      y.add(d.getFullYear())
    } else {
      y.add('other')
    }
  })
  return Array.from(y).sort((a, b) => a - b).reverse()
}

export function getTypes (list = []) {
  const all = list.reduce((a, c) => a.concat(...c.types), [])
  const result = []
  const map = new Map()

  for (const item of all) {
    if (!map.has(item.autoid)) {
      map.set(item.autoid, true)
      result.push(item)
    }
  }
  return result.sort((a, b) => a.id.localeCompare(b.id))
}

export function getAssemblies (list = []) {
  const all = list.reduce((a, c) => a.concat(...c.assemblies), [])
  const result = []
  const map = new Map()

  for (const item of all) {
    if (!map.has(item.autoid)) {
      map.set(item.autoid, true)
      result.push(item)
    }
  }
  return result.sort((a, b) => a.id.localeCompare(b.id))
}

export function setupAnnotations () {
  this.$nextTick(() => {
    let count = 1
    const footnotes = document.getElementById('footnotes')
    footnotes.innerHTML = ''
    const annotations = document.querySelectorAll('.annotation')

    for (const annotation of annotations) {
      const counters = [...annotation.getElementsByClassName('annotation-counter')]
      annotation.getElementsByClassName('annotation-target')[0].setAttribute('id', `annotation-${count}`)
      annotation.getElementsByClassName('annotation-ring')[0].setAttribute('id', `annotation-ring-${count}`)
      counters.forEach(x => {
        x.innerText = count
      })
      const annotationCopy = annotation.cloneNode(true)
      const footnoteLink = document.createElement('a')
      footnoteLink.classList.add('annotation-link')
      footnoteLink.setAttribute('href', `#annotation-${count}`)
      footnoteLink.innerText = '↑'
      const annotationId = `annotation-ring-${count}`
      footnoteLink.addEventListener('click', (e) => {
        e.preventDefault()
        const el = document.getElementById(annotationId)
        VueScrollTo.scrollTo(el, 150, {
          easing: 'ease-out',
          offset: -250
        })
        el.classList.remove('animate')
        setTimeout(() => {
          el.classList.add('animate')
        }, 100)
      })
      annotationCopy.appendChild(footnoteLink)
      footnotes.appendChild(annotationCopy)
      count = count + 1
    }

    this.$nextTick(() => {
      adjustAnnotations()
    })
  })
}

export function cumulativeOffset (element) {
  var top = 0
  var left = 0

  do {
    top += element.offsetTop || 0
    left += element.offsetLeft || 0
    element = element.offsetParent
  } while (element)

  return {
    top: top,
    left: left
  }
}

// Prevent collisions of annotations
export function adjustAnnotations () {
  const annotations = [...document.querySelectorAll('.content-block span.annotation-content')]
  const minOffset = 24

  annotations.slice().map((x) => {
    x.style.paddingTop = 0
  })

  if (annotations.length > 1) {
    let counter = 0
    for (const annotation of annotations) {
      if (counter > 0) {
        const prev = annotations[counter - 1]
        const prevBottom = cumulativeOffset(prev).top + prev.clientHeight + minOffset
        const currentTop = cumulativeOffset(annotation).top

        if (currentTop < prevBottom) {
          const newTop = prevBottom - currentTop
          annotation.style.paddingTop = `${newTop}px`
        }
      }
      counter++
    }
  }
}

export function smImg (img) {
  if (typeof img === 'string') return img
  if (img.sizes && img.sizes.sm) {
    return img.sizes.sm.src
  }
  return img.srcset && img.srcset.split(' ')[0]
}

export function mdImg (img) {
  if (typeof img === 'string') return img
  if (img.sizes && img.sizes.md) {
    return img.sizes.md.src
  }
  return img.srcset && img.srcset.split(' ')[2]
}

export function lgImg (img) {
  if (typeof img === 'string') return img
  if (img.sizes && img.sizes.lg) {
    return img.sizes.lg.src
  }
  return img.srcset && img.srcset.split(' ')[4]
}
